// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"773":"dac4869d","8722":"9c582a3e"}[chunkId] + ".chunk.css";
};